import React from 'react'
import { useTranslation } from 'react-i18next'
import {Theme, withTheme} from '@emotion/react';
import { ReactComponent as AuthorizedIcon } from '../../svg/icon-authorized.svg'
import { Heading, Text } from '../../components/Library/Typography'
import { Flex } from '../../components/Library/Flex'
import { Footer } from '../../components/Footer'
import { LogoHeader } from '../../components/LogoHeader'
import {
  BorderBottom,
  InlineExternalLink,
  PrimaryButton,
  LinkButton,
  Content,
} from '../../components/Library'
import {PageContent} from "../../components/PageContent";
import { TERMS_OF_USE_URL, PRIVACY_POLICY_URL, CONTACT_US_URL } from '../../constants/externalUrls'

interface Props {
  acceptTerms: () => void
  declineTerms: () => void
  clinicName: string | undefined
}

export const Layout: React.FC<Props> = withTheme(({
  acceptTerms,
  declineTerms,
  clinicName,
  theme
}: Props & { theme: Theme }) => {
  const { t } = useTranslation()
  return (
    <>
      <LogoHeader />

      <PageContent banner={theme.pageBannerStyle === 'curved' && {title: t('start.welcome')}}>

        <Content px={25} py={3} alignItems="center">
          <Flex flexDirection="column" alignItems="center" pb={0}>
            {theme.pageBannerStyle !== 'curved' && <AuthorizedIcon width="70" height="70" />}
            <Heading mb="0px">{t('acceptTerms.title')}</Heading>
          </Flex>
          <BorderBottom pb={3} mb={3}>
            <Text textStyle="normal" textAlign="center">
              {t('acceptTerms.reviewMessageTitle', { clinicName })}
            </Text>
          </BorderBottom>
          <Text textStyle="normal" pb={3}>
            {t('acceptTerms.chooseReceiveText')}{' '}
            <InlineExternalLink href={CONTACT_US_URL}>nav.care/help</InlineExternalLink>.{' '}
            {t('acceptTerms.moreInformation')}{' '}
            <InlineExternalLink href={PRIVACY_POLICY_URL}>
              {t('acceptTerms.privacyPolicy')}
            </InlineExternalLink>{' '}
            {t('acceptTerms.orSee')}{' '}
            <InlineExternalLink href={CONTACT_US_URL}>
              {t('acceptTerms.FAQ')}
            </InlineExternalLink>{' '}
            {t('acceptTerms.texingStop')}
          </Text>
          <Flex mb={4} flexDirection="column" alignItems="center">
            <Text textStyle="normal" pb={4}>
              {t('acceptTerms.acceptingNC')}{' '}
              <InlineExternalLink href={TERMS_OF_USE_URL}>
                {t('acceptTerms.termsOfUse')}
              </InlineExternalLink>
            .
            </Text>
            <PrimaryButton data-testid="accept-terms" onClick={acceptTerms}>
              {t('acceptTerms.continue')}
            </PrimaryButton>
            <LinkButton onClick={declineTerms}>
              {t('acceptTerms.decline')}
            </LinkButton>
          </Flex>
        </Content>
      </PageContent>

      <Footer />
    </>
  )
})
